import React, {Component} from "react";
import {Container, Col, Row, Image} from "react-bootstrap";

export class CopyRight extends Component {
    render() {
        return (
            <div className="sub-footer pt-20 pb-20 bord-thin-top">
                <Container>
                    <Row>
                        <Col lg={12} className='m-auto'>
                            <div className="copyright d-flex">
                                <div className="m-auto">
                                    <p className="fz-13 padding-rl-15">
                                        © حقوق این سایت متعلق به شرکت سرمایه‌گذاری عمران و توسعه پایدار ایرانیان (سهامی خاص) می‌باشد.
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}
